<template>
    <div class="global">
        <header class="global-header">
            <div class="line-item">
                <div class="back-btn" aria-hidden="true">
                    <md-button class="md-icon-button" @click="navToClientList()">
                        <md-icon>arrow_back</md-icon>
                    </md-button>
                </div>
                <div class="left-item">
                    <div class="el">
                        <h1 v-if="clientActive">{{ currentClientName }} Settings</h1>
                        <h1 v-else>Cortex Settings</h1>
                    </div>
                </div>
                <div class="right-item">
                    <div class="el">
                        <div class="md-layout-item">
                            <md-field>
                                <md-select v-model="country" name="country" id="country" placeholder="Available Reports">
                                    <md-option value="australia" title="Reports">
                                        <downloadexcel class="btn" name="User Information Report.xls" :fetch="fetchData" :fields="json_fields" type="csv">
                                            User Information
                                        </downloadexcel>
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                    </div>
                    <div class="el header-avatar">
                        <md-button class="avatar-button" @click="showCurrentUserProfile()">
                            <md-avatar v-if="currentUser.avatar" class="md-avatar-icon">
                                <img :src="getImageSrc(currentUser.avatar)">
                            </md-avatar>
                            <md-avatar v-else class="md-avatar-icon blue">
                                {{ getUserInitials(currentUser) }}
                            </md-avatar>
                        </md-button>
                    </div>
                    <div class="el">
                        <md-button class="md-icon-button">
                            <md-icon>settings</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
            <div class="client-tabs btn-position-wrap">
                <md-tabs class="centered-title md-tabs-wrapper container" md-sync-route md-alignment="left">
                    <md-tab v-if="isAdmin" md-label="General" to="/settings/general"/>
                    <md-tab md-label="Users" to="/settings/users"/>
                    <md-tab v-if="isAdmin" md-label="Support" to="/settings/usermanual"/>
                    <md-tab md-label="Version " to="/settings/release"/>
                    <md-tab v-if="isAdmin" md-label="Export Jobs" to="/settings/exportjobs"/>
                    <md-tab v-if="isAdmin" md-label="LOG IN HISTORY" to="/settings/lohinhistory"/>
                    <md-tab v-if="isAdmin" md-label="ENABLE INCOMPLETE TOURS" to="/settings/enableincompletetours"/>
                </md-tabs>
            </div>
        </header>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import downloadexcel from 'vue-json-excel';
import {exportAllUserService} from '../../services/ClientService.js';

export default {
  name: 'BasicSelect',
  components: {
    downloadexcel
  },
  data: () => ({
    returnPath: null,
    country: null,
    json_fields: {
      'FirstName': 'firstName',
      'LastName': 'lastName',
      'Email': 'email',
      'Roles': 'roles',
      'OfficePhone': 'officePhone',
      'DirectPhone': 'directPhone',
      'Cortex admin': 'isAdmin',
      'Company Name': 'companyName'
    }
  }),
  methods: {
    ...mapActions('user', ['setUserToEdit']),
    navToClientList () {
      this.$router.push({path: this.returnPath});
    },
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials (user) {
      let userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    showCurrentUserProfile () {
      this.setUserToEdit(this.currentUser);
      this.$router.push('/user');
    },
    async fetchData () {
      const response = await exportAllUserService();
      return response.data;
    }
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'currentUser']),
    ...mapGetters('client', ['clientActive', 'currentClientName'])
  },
  mounted () {
    if (this.clientActive && this.currentUser.isAdmin === 1) {
      this.returnPath = '/client/tours';
    } else {
      if (this.currentUser.isAdmin === 1) {
        this.returnPath = '/client/list';
      } else {
        this.returnPath = '/clients/switch';
      }
    }
  }
};
</script>
<style scoped type="scss">
.md-list-item .md-button-clean {
    text-transform: none !important;
}

.md-tabs-navigation {
}

.md-tabs-indicator {
    height: 3px !important;
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

hr {
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    color: #e0e0e0;
}

.header-avatar .md-button {
    top: 13px;
    height: 40px;
    width: 40px;
    min-width: 40px !important;
    margin: 0;
}

.page-content {
    padding-top: 48px;
}

.avatar-button {
    font-weight: 300 !important;
}

.pencilSelected {
    width: auto;
    cursor: pointer;
    margin-top: 19px;
    max-width: 29px;
    margin-right: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue